import { makeActionCreator } from '../../config/store/utils'
import { createComparatorTraded } from '../../services/comparatorCharts'
import theme from '../../config/styles/theme'

export const COMPARATOR_TRADED_AMOUNTS = 'COMPARATOR_TRADED_AMOUNTS'
export const COMPARATOR_TRADED_AMOUNTS_ERROR = 'COMPARATOR_TRADED_AMOUNTS_ERROR'
export const COMPARATOR_TRADED_AMOUNTS_SUCCESS = 'COMPARATOR_TRADED_AMOUNTS_SUCCESS'
export const onComparatorTradedAmounts = makeActionCreator(COMPARATOR_TRADED_AMOUNTS)
export const onComparatorTradedAmountsError = makeActionCreator(COMPARATOR_TRADED_AMOUNTS_ERROR, 'payload')
export const onComparatorTradedAmountsSuccess = makeActionCreator(COMPARATOR_TRADED_AMOUNTS_SUCCESS, 'payload')
export const onComparatorTradedAmountsThunk =
  ({ year, idEntity }, type) =>
  async dispatch => {
    dispatch(onComparatorTradedAmounts())

    try {
      const response = await createComparatorTraded({ year, idEntity })

      if (response.data.success !== 'OK') {
        return dispatch(onComparatorTradedAmountsError(response.data.errores))
      }

      const colors = [theme.palette.charts.navyBlue, theme.palette.charts.darkRed]
      const arrayFirstAmount = response.data.payload.map(({ year, data1: innerData }) => ({
        year,
        amount: innerData.map(({ amount }) => amount),
        month: innerData.map(({ month }) => month),
        name: innerData[0].name,
        percentageAccumulative: innerData.map(({ percentAmountAcumCLP }) => percentAmountAcumCLP),
        percentageMonth: innerData.map(({ percentAmountMonthCLP }) => percentAmountMonthCLP),
        totalAmount: innerData.map(({ totalAmount }) => totalAmount)
      }))
      const arraySecondAmount = response.data.payload.map(({ year, data2: innerData }) => ({
        year,
        amount: innerData.map(({ amount }) => amount),
        month: innerData.map(({ month }) => month),
        name: innerData[0].name,
        percentageAccumulative: innerData.map(({ percentAmountAcumCLP }) => percentAmountAcumCLP),
        percentageMonth: innerData.map(({ percentAmountMonthCLP }) => percentAmountMonthCLP),
        totalAmount: innerData.map(({ totalAmount }) => totalAmount)
      }))
      const arrayAmounts = [...arrayFirstAmount, ...arraySecondAmount]
      const chartStructure = arrayAmounts.map((item, index) => ({
        amount: item.amount,
        color: colors[index],
        data: item[type],
        month: item.month,
        name: item.name,
        percentageAccumulative: item.percentageAccumulative,
        percentageMonth: item.percentageMonth,
        totalAmount: item.totalAmount,
        year: item.year
      }))
      const jsonArray = arrayAmounts.map(item =>
        item.amount.map((_, index) => ({
          amount: item.amount[index],
          anual: item.year,
          entity: item.name,
          month: item.month[index],
          percentageAccumulative: item.percentageAccumulative[index],
          percentageMonth: item.percentageMonth[index],
          totalAmount: item.totalAmount[index]
        }))
      )
      const newArray = [].concat.apply([], jsonArray)
      const categories = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ]
      const csvStructure = [
        [
          'Organismo',
          'Año',
          'Mes',
          'Monto (CLP)',
          'Total Acumulado (CLP)',
          'Monto porcentual mensual',
          'Monto porcentual acumulado'
        ],
        ...newArray.map(item => [
          item.entity,
          item.anual,
          item.month,
          item.amount,
          item.totalAmount,
          item.percentageMonth,
          item.percentageAccumulative
        ])
      ]
      const payload = { categories, chartStructure, csvStructure }

      return dispatch(onComparatorTradedAmountsSuccess(payload))
    } catch (error) {
      return dispatch(onComparatorTradedAmountsError(error))
    }
  }
